import { render, staticRenderFns } from "./page.vue?vue&type=template&id=9e0264ca"
import script from "./page.vue?vue&type=script&lang=js"
export * from "./page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e0264ca')) {
      api.createRecord('9e0264ca', component.options)
    } else {
      api.reload('9e0264ca', component.options)
    }
    module.hot.accept("./page.vue?vue&type=template&id=9e0264ca", function () {
      api.rerender('9e0264ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm_fine/views/activity_center/activity_overview/page.vue"
export default component.exports